module.exports = __webpack_public_path__ + "static/media/logo.96d6935d.png";